import { useTranslator } from '@bluebeam/react-i18n';
import ECSEditor from 'components/editor/ECSEditor';
import ECSSheet from 'components/editor/ECSSheet';
import { ModalStaticProperties } from 'components/ModalPortal/ModalPortal';
import ModalStdHeader from 'components/modals/ModalStdHeader';
import ZoomControls from 'components/viewer/toolbars/ZoomControls';
import React, { useState } from 'react';
import { DocId } from 'records/Doc';
import { PageId } from 'records/Page';
import { PublishRequest } from 'records/PublishRequest';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import PubReqSidebar from './PubReqSidebar';
import PubReqViewerModalFooter from './PubReqViewerModalFooter';

interface Props extends WithAppStoreProps {
  pageId: PageId;
  documentId: DocId;
}

const editorContainerId = 'pub-req-viewer-container';

const PubReqViewerModal: React.FC<Props> & ModalStaticProperties = ({
  pageId,
  documentId,
  appState,
}) => {
  const { publishRequests } = appState;
  const publishRequest = publishRequests.get(pageId, new PublishRequest());
  const { translate } = useTranslator(['pubReqViewerModal']);
  const [currentPageId, setCurrentPageId] = useState(pageId);

  const handlePageChange = (nextPageId: PageId): void => {
    setCurrentPageId(nextPageId);
  };

  return (
    <div id="pub-req-viewer-modal" className="column oys h100">
      <ModalStdHeader text={translate('pubReqViewerModal:drawingPreview')} />
      <div className="pt7 grow-1">
        <div
          className="row h100"
          style={{ backgroundColor: 'rgb(195, 197, 201)' }}
        >
          <div className="grow-1">
            <ECSEditor
              containerId={editorContainerId}
              isModal
              isScrollable={false}
            >
              <ECSSheet
                documentid={documentId}
                pageid={currentPageId}
                withMarkups={false}
                isInteractive={false}
              />
              <ZoomControls />
            </ECSEditor>
          </div>
          <PubReqSidebar key={currentPageId} publishRequest={publishRequest} />
        </div>
      </div>
      <PubReqViewerModalFooter
        publishRequest={publishRequest}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

PubReqViewerModal.modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  content: {
    padding: '0',
    margin: '0',
    left: '1rem',
    top: '1rem',
    right: '1rem',
    bottom: '1rem',
    borderRadius: '8px',
    border: 'none',
  },
};

export default withAppStore(PubReqViewerModal);
